import { Helmet } from "react-helmet-async"
import { SupplierPayments } from "../../../../../Supplier"
import { useParams } from "../../../../../router-utils"

export default function TransportServiceProviderPaymentsPage() {
	const { supplierId } = useParams("/suppliers/:supplierId/payments/incoming")
	return (
		<>
			<Helmet>
				<title>Incoming Payments | Suppliers</title>
			</Helmet>
			<SupplierPayments supplierId={supplierId} paymentType="credit" />
		</>
	)
}
